import React, { useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';

import { CustomersGridContainer } from './containers/customers-grid-container';
import { CustomersGridHeaderContainer } from './containers/customers-grid-header-container';
import PagingControlContainer from './containers/customers-grid-paging-container';
import { CustomersLeftNav } from './containers/customers-left-nav-container';
import EditColumnsButtonContainer from '../../components/edit-columns-button/containers/customer-grid-container';
import ErrorBoundary from '../../components/error-boundary';
import GridLoading from '../../components/grid-loading';
import { CreateLabelContentModal } from '../../components/modals/customers-create-label-modal/modal';
import Page from '../../components/page';
import ToggleLeftNav from '../../components/toggle-left-nav';
import { CustomersFilterBarContainer } from '../../containers/customers-filter-bar-container';
import { emptyArray } from 'ui-components/default-props/empty';
import { closeCustomersCreateLabelModal } from '../../store/customers/create-label/customers.create-label.actions';
import { setSelectedCustomers } from '../../store/customers/selected-customers/customers.selected-customers.actions';
import style from '../grid-page.module.less';

/**
 * @param {object} props
 * @param {boolean} [props.isLoading] - Whether the page is loading
 * @param {boolean} [props.shouldOpenCreateLabelModal] - Whether to open the create label modal
 * @returns {React.ReactElement} The customers page component
 */
const CustomersPage = ({ isLoading = false, shouldOpenCreateLabelModal = false }) => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(closeCustomersCreateLabelModal());
  }, [dispatch]);

  useEffect(() => {
    return () => dispatch(setSelectedCustomers(emptyArray));
  }, [dispatch]);

  return (
    <>
      <Page testId='customers-page'>
        <div className={style['grid-page']}>
          <ToggleLeftNav>
            <CustomersLeftNav />
          </ToggleLeftNav>
          <div className={style['main-content']}>
            <CustomersGridHeaderContainer>
              <EditColumnsButtonContainer />
            </CustomersGridHeaderContainer>
            <div className={classnames(style['edit-grid-wrap'], style['edit-grid-wrap-no-filters'])}>
              <div className={style['grid-filter-wrap']}>
                {shouldOpenCreateLabelModal ? <CreateLabelContentModal onClose={onClose} /> : null}
                <CustomersFilterBarContainer />
              </div>
            </div>
            <div className={style['grid-content']}>
              <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
                <div className={style.grid}>
                  {isLoading ? <GridLoading /> : null}
                  <ErrorBoundary errorMessageId='customersGrid'>
                    <CustomersGridContainer />
                  </ErrorBoundary>
                </div>
                <div className={[style['paging-footer']]}>
                  <PagingControlContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
    </>
  );
};

export { CustomersPage };
